import { render, staticRenderFns } from "./add-insurancechannel-info-modal.vue?vue&type=template&id=0af48cfd"
import script from "./add-insurancechannel-info-modal.vue?vue&type=script&lang=js"
export * from "./add-insurancechannel-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports